import React, { ReactNode } from "react"

import { FormControlLabel, Radio } from "@mui/material"
import { RadioProps } from "@mui/material/Radio/Radio"

import { useFormControlLabelClasses, useRadioClasses } from "./styles"

interface IProps extends RadioProps {
  className?: string,
  label: ReactNode
}

export const LabeledRadio = (props: IProps) => {
  return <FormControlLabel
    sx={props.sx}
    className={props.className}
    classes={useFormControlLabelClasses()}
    label={props.label}
    control={
      <Radio
        {...props}
        color={"default"}
        classes={useRadioClasses({
          checked: props.checked,
          color: props.color || "primary"
        })}
      />
    }
  />
}
